import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-system-update-form',
  templateUrl: './system-update-form.component.html',
  styleUrls: ['./system-update-form.component.scss']
})
export class SystemUpdateFormComponent implements OnInit {
  @Input() update: any = null;
  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  form!: FormGroup;
  submitting = false;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '260px',
    minHeight: '160px',
    placeholder: 'Describe this system update...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: '',
    toolbarHiddenButtons: [
      ['subscript', 'superscript'],
      ['insertVideo']
    ],
    uploadWithCredentials: false
  };

  constructor(
    private fb: FormBuilder,
    private supportService: SupportService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      title: [this.update?.title || '', Validators.required],
      state: [this.update?.state || 'planned', Validators.required],
      body: [this.update?.body || '', Validators.required]
    });
  }

  get isEdit(): boolean {
    return !!this.update?._id;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = this.form.value;
    this.submitting = true;
    this.spinner.show('su-form-spinner');

    const request$ = this.isEdit
      ? this.supportService.updateSystemUpdate(this.update._id, payload)
      : this.supportService.createSystemUpdate(payload);

    request$.subscribe({
      next: () => {
        this.submitting = false;
        this.spinner.hide('su-form-spinner');
        this.toastr.success(this.isEdit ? 'Update saved' : 'Update created');
        this.saved.emit();
      },
      error: (err: any) => {
        this.submitting = false;
        this.spinner.hide('su-form-spinner');
        this.toastr.error(err.error?.response?.message || 'Failed to save update');
      }
    });
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
